/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Filter_No_TcInputs */

const en_editor_filter_no_tc = /** @type {(inputs: Editor_Filter_No_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No TC`)
};

const fr_editor_filter_no_tc = /** @type {(inputs: Editor_Filter_No_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas de TC`)
};

const de_editor_filter_no_tc = /** @type {(inputs: Editor_Filter_No_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein TC`)
};

const it_editor_filter_no_tc = /** @type {(inputs: Editor_Filter_No_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun TC`)
};

const ru_editor_filter_no_tc = /** @type {(inputs: Editor_Filter_No_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Без ТС`)
};

const es_editor_filter_no_tc = /** @type {(inputs: Editor_Filter_No_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin TC`)
};

const zh_cn2_editor_filter_no_tc = /** @type {(inputs: Editor_Filter_No_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无TC`)
};

const ja_editor_filter_no_tc = /** @type {(inputs: Editor_Filter_No_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TCなし`)
};

const hi_editor_filter_no_tc = /** @type {(inputs: Editor_Filter_No_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई टीसी नहीं`)
};

const pt_pt2_editor_filter_no_tc = /** @type {(inputs: Editor_Filter_No_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem TC`)
};

/**
* | output |
* | --- |
* | "No TC" |
*
* @param {Editor_Filter_No_TcInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_filter_no_tc = /** @type {((inputs?: Editor_Filter_No_TcInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Filter_No_TcInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_filter_no_tc(inputs)
	if (locale === "de") return de_editor_filter_no_tc(inputs)
	if (locale === "it") return it_editor_filter_no_tc(inputs)
	if (locale === "ru") return ru_editor_filter_no_tc(inputs)
	if (locale === "es") return es_editor_filter_no_tc(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_filter_no_tc(inputs)
	if (locale === "ja") return ja_editor_filter_no_tc(inputs)
	if (locale === "hi") return hi_editor_filter_no_tc(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_filter_no_tc(inputs)
	return en_editor_filter_no_tc(inputs)
});